import { render, staticRenderFns } from "./AssignCoordinatorApproveDialog.vue?vue&type=template&id=10274b9c&scoped=true"
import script from "./AssignCoordinatorApproveDialog.vue?vue&type=script&lang=js"
export * from "./AssignCoordinatorApproveDialog.vue?vue&type=script&lang=js"
import style0 from "./AssignCoordinatorApproveDialog.vue?vue&type=style&index=0&id=10274b9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10274b9c",
  null
  
)

export default component.exports